export const EtiquetasGenerales_EN = {
    General: {
        //---------------------ENCABEZADOS------------------------------
        Et_TituloEliminaRegistro: 'Delete record',
        Et_TituloCriterioBusqueda: 'Search criteria',
        Et_TituloCamposDinamicos: 'My Fields',
        Et_TituloConfirmaregistro: 'Confirmation',
        Et_TituloDialogoMensaje: 'Message',
        //---------------------Confirmaciones---------------------------
        TextoEliminarRegistro: 'Do you want to delete the record? ',
        //---------------------BOTONES----------------------------------
        Et_tbnInsertar: 'Create',
        Et_tbnEditar: 'Edit',
        Et_tbnGuardar: 'Save',
        Et_tbnAceptar: 'Accept',
        Et_tbnCancelar: 'Cancel',
        Et_tbnEliminar: 'Delete',
        Et_tbnFavorito: 'Favorite',
        Et_tbnPrincipal: 'Main',
        Et_tbnLimpiar: 'Clear',
        Et_tbnSi: 'Yes',
        Et_tbnNo: 'No',
        Et_tbnAtras: 'Back',
        Et_tbnSiguiente: 'Next',
        Et_tbnBusqueda: 'Search',
        Et_tbnCerrarSesion: 'Logout',
        Et_tbnSubir: 'Upload',
        Et_tbnBajar: 'Download',
        Et_tbnCerrar: 'Close',
        Et_tbnEliminarRegistro: "Yes, delete the record",
        Et_tbnMantenerRegistro: "No, keep the record",
        Et_tbnAgregar: 'Add',
        Et_tbnConfirmar: 'Confirm',
        Et_tbnCambiarContrasena: 'Change Password',
        //---------------------TABLAS-----------------------------------
        Et_tblAcciones: 'Actions',
        Et_tblDetalles: 'Details',
        Et_tblTableEmty: 'No data available',
        Et_tblItems: 'Rows per page: ',
        Et_tblItemsDescription: 'Visible rows from {0} to {1} of {2} total.',
        //---------------------TEXTOS--------------------------------
        Et_tblSiTildado: 'Yes',
        Et_lblEs: 'Spanish',
        Et_lblEn: 'English',
        Et_lblAllElemnts: 'All',
        Et_lblTodosRegistros: 'All',
        Et_tblNombre: 'Name',
        Et_tblCode: 'Code',
        Et_tblDescripcion: 'Description',
        Et_tblEstado: 'Status',
        Et_tblActivo: 'Active',
        Et_tblInactivo: 'Inactive',
        Et_Select: 'Select',
        Et_Seleccionar: 'Select',
        Et_NoAplica: 'Not applicable',
        Et_tblCusIde: 'Identification',
        Et_tblCusOtherIdeShort: 'CIF',
        Et_tblCusOtherIde: 'CIF Number',
        Et_tblObservation: 'Observations',
        Et_tblClasificacion: 'Classification',
        Et_tblCategoria: 'Category',
        Et_tblTipo: 'Type',
        Et_tblTipoRequisito: 'Mandatory',
        Et_tblTipoOpcional: 'Optional',
        Et_tblBloque: 'Block',
        Et_tblRequisitos: 'Requirements',
        Et_tblFormatoArchivosPermitidos: 'File Formats',
        Et_Requisito: 'Requirement',
        Et_tblRequisitoConAdjunto: 'The requirement requires attaching a file.',
        Et_tblAdminFormatoAdjunto: 'Manage allowed formats',
        Et_tblAdjunto: 'Attachment',
        Et_tblSinOpciones: 'No options',
        Et_tblDatosGenerales: 'General Data',
        Et_tblPrograma: 'Program',
        Et_tblProgramas: 'Programs',
        Et_tblTipoPeriodo: 'Period Type',
        Et_tblPeriodo: 'Period',
        Et_tblAnno: 'Year',
        Et_tblSede: 'Campus',
        Et_tblSedes: 'Campuses',
        Et_tblFechaAprobacion: 'Approval Date',
        Et_tblEstudiante: 'Student',
        Et_tblAprobacion: 'Approval',
        Et_tblArchivo: 'File',
        Et_tblCompania: 'Company',
        Et_tblComentarios: 'Comments',
        Et_tvlAula: 'Classroom',
        Et_tvlAulas: 'Classrooms',
        Et_tvlRecursos: 'Resources',
        Et_tvlEdificio: 'Building',
        Et_tvlPiso: 'Floor',
        Et_tvlTipoAula: 'Classroom Type',
        Et_tvlCapacidad: 'Capacity',
        Et_tvlDireccion: 'Address',
        Et_tvlAulaDiscapaitados: 'Enabled for disabled',
        Et_tvlCantidad: 'Quantity',
        Et_tblAprobado: 'Approved',
        Et_tblPendiente: 'Pending',
        Et_tvlJornada: 'Schedule',
        Et_tvHoraIncio: 'Start Time',
        Et_tvHoraFinal: 'End Time',
        Et_tvDiasSemana: 'Weekdays',
        Et_tvLunes: 'Monday',
        Et_tvMartes: 'Tuesday',
        Et_tvMiercoles: 'Wednesday',
        Et_tvJueves: 'Thursday',
        Et_tvViernes: 'Friday',
        Et_tvSabado: 'Saturday',
        Et_tvDomingo: 'Sunday',
        Et_tvListaRecursos: 'Resource List',
        Et_tblInfoRegistrosActivos: '*Only active records will be displayed.',
        Et_FiltroDscRecursos: 'Resource Description',
        Et_FiltroDscSede: 'Campus Description',
        Et_FiltroDscCursos: 'Course Description',
        Et_FiltroDscFormatos: 'Format Description',
        Et_tblGrupo: 'Group',
        Et_tblSubGrupo: 'Subgroup',
        Et_tblPublicada: 'Published',
        Et_tblCupo: 'Capacity',
        Et_tblIniciaT: 'Starts: ',
        Et_tblFinalizaT: 'Ends: ',
        Et_Profesor: 'Professor',
        Et_Dia: 'Day',
        Et_Horario: 'Schedule',
        Et_tblDetalleFechas: 'Date Details',
        Et_tblPeriodoAcademico: 'Academic Period',
        Et_tblInscripciones: 'Enrollments',
        Et_tblInicioPeriodo: 'Start Period',
        Et_tblFinPeriodo: 'End Period',
        Et_tblUsuario: 'User',
        Et_tblCliente: 'CIF',
        Et_tblAccion: 'Action',
        Et_tblFechaDesde: 'Start Date',
        Et_tblFechaHasta: 'End Date',
        Et_tblGeneral: 'General',
        Et_LblEmail: 'Email',
        Et_LblEstudiantes: 'Students',
        Et_tblIntensidadHoraria: 'Hourly Intensity',
        Et_ValidaCampoRequerido: 'The field {0} is required.',
        Et_MensajeCodigoSistema: 'This is a system code, you can select an item from the list or clear the text and add a new item using the add (+) button.',
        Et_tblTodos: 'All',
        Et_Descargar: 'Download',
        Et_VerMas: 'See more'
    },
    Buscadores: {
        Et_BuscarEmpresa: 'Search Company',
        Et_BuscarPoliticaFinanciamiento: 'Search Financing Policies',
        Et_lblUsuarios: 'Search Users',
        Et_lblCarreras: 'Search Careers',
        Et_lblCursos: 'Search Courses',
        Et_lblRegistrosActivos: '*Only active records will be displayed.',
        Et_lblProgramas: 'Search Programs',
        Et_lblSedes: 'Search Campuses',
        Et_lblClientes: 'Search CIF',
        Et_lblIngresarID: 'Enter identification',
        Et_lblCursosProgramas: 'Search Course Programs',
        Et_lblAulas: 'Search Classrooms',
    },
    Reportes: {
        Et_TituloPrincipal: 'Reports',
        Et_LblExportaPdf: 'Pdf',
        Et_LblExportaXls: 'Xls',
        Et_LblExportaDoc: 'Doc'
    },
    Login: {
        Et_btnAcceso: 'Access',
        Et_btnAccesoAAD: 'Continue with Office 365',
        Et_TituloPrincipal: 'User Login',
        Et_txtUsuario: 'Enter your username',
        Et_txtPassword: 'Enter your password'
    },
    HomeModulo: {
        Et_Titulo: 'Explore the different submodules',
        Et_Parrafo1: 'In the left panel, you can find the content you are looking for. Try using',
        Et_Parrafo2: 'Favorites or Menu'
    },
    NotFound: {
        Et_btnAccion: 'Return to Home'
    },
    AppBarLang: {
        Et_TituloPrincipal: 'Academic Management System'
    },
    DetalleModulo: {
        Et_BtnAccion: 'Go to Module',
        Et_TituloFavoritos: 'MOST USED MODULES',
    },
    IdiomaModal: {
        Et_TituloPrincipal: 'Select Your Language'
    },
    MenuDerecha: {
        Et_btnSalir: 'Exit',
    },
    MenuIzquierda: {
        Et_LblHeader: 'Academic Module',
        Et_LblFavoritos: 'Favorites',
        Et_LblSubmodulos: 'Menu'
    },
    IdleTimeOutModal: {
        Et_txtFinSesionTitulo: 'Your session time has expired.',
        Et_txtFinSeguir: 'Do you want to continue browsing?'
    },
    CalendarioSimple: {
        Date: 'Date',
        Time: 'Time',
        Event: 'Event',
        AllDay: 'All Day',
        Week: 'Week',
        Work_week: 'Work Week',
        Day: 'Day',
        Month: 'Month',
        Previous: 'Previous',
        Next: 'Next',
        Today: 'Today',
        Yesterday: 'Yesterday',
        Tomorrow: 'Tomorrow',
        Agenda: 'Agenda',
        NoEventsInRange: 'No events in this range.',
        ShowMore: 'more',
        CrearEvento: 'Create Event'
    },
    CargandoModal: {
        Et_Procesando: "Processing, please wait.",
        Et_Cargando: "Loading, please wait."
    },
    ToolbarButtons: {
        Et_BtnEnviar: 'Send',
        Et_BtnCamposDinamicos: 'My Fields',
        Et_BtnAjustes: 'Settings',
        Et_BtnImprimir: 'Print'
    },
    DialogoSubirImagen: {
        Et_TituloPrincipal: 'Upload Image',
        Et_FotoPerfil: 'Profile Picture',
        Et_BtnSubir: 'Upload Photo',
        Et_BtnCamara: 'Take Photo'
    },
    DialogoSubirArchivo: {
        Et_TituloPrincipal: 'Upload File',
        Et_NombreArchivo: 'File Name'
    },
    DialogoWebCam: {
        Et_TituloPrincipal: 'Capture Image',
        Et_BtnCamara: 'Capture'
    },
    ListaCompanias: {
        Et_TituloPrincipal: 'Company Query',
        Et_Descripcion: 'Company parameter management.'
    },
    MantenimientoCompanias: {
        Et_TituloPrincipal: 'Company Maintenance',
        Et_Descripcion: 'Company parameter management.',
        Et_LblTipoCifs: 'Types of CIF',
        Et_LblModoGenerar: 'Generation Mode',
        Et_LblModoGenerarManual: 'Manual',
        Et_LblModoGenerarAutomatico: 'Automatic'
    },
    ControlFlujoCliente: {
        Et_TituloPrincipal: 'Process Flow',
    },
    ListaSedes: {
        Et_TituloPrincipal: 'Campus Query',
        Et_Descripcion: 'Campus parameter management.'
    },
    MantenimientoSedes: {
        Et_TituloPrincipal: 'Campus Maintenance',
        Et_Descripcion: 'Campus parameter management.'
    },
    Mensajeria: {
        Et_TituloPrincipal: 'MESSAGING',
        Et_Descripcion: 'My messages',
        Et_LblBuzonEntrada: 'Inbox',
        Et_LblBuzonSalida: 'Outbox',
        Et_LblNuevoMensaje: 'New message',
        Et_LblResponderMensaje: 'Reply message',
        Et_LblLeidos: 'Read',
        Et_LblMensajeDe: 'Message from:',
        Et_LblMensajeDescrip: 'Message Description',
        Et_LblFechaHora: 'Date and Time',
        Et_LblElementosSeleccionados: '{0} selected messages',
        Et_LblElementosSeleccionadosEliminar: 'Do you want to delete the {0} selected messages?',
        Et_LblMarcarLeidos: 'Mark as read',
        Et_LblMarcarNoLeidos: 'Mark as unread',
        Et_LblEliminarMultiples: 'Delete selected messages',
        Et_LblPara: 'To:',
        Et_LblCopia: 'CC:',
        Et_tblAsunto: 'Subject',
        Et_tblDestinatario: 'Recipient',
        Et_tblRemitente: 'Sender',
        Et_tblDescartar: 'Discard',
        Et_tblDetallesMensaje: 'Message Details',
        Et_tblResponder: 'Reply',
        Et_tblAdjuntarArchivo: 'Attach file',
        Et_LblBuscarCorreo: 'Search email',
    },
    PaginacionTabla: {
        Et_FilasPagina: 'Rows per page:',
        Et_Elementos: '{0} - {1} of {2}',
    },
    CambiosPendientes: {
        Et_tblTextoCambiosPendientes: 'Pending Changes',
        Et_tblTextoValidarTitulo: 'Do you want to exit the option?\n\t',
        Et_tblTextoValidarSubTitulo: 'Exiting will discard any unsaved changes.',
    }
};